import React from 'react';
import {
  FolderIcon,
  TrashIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';
import './BulkActionBar.css';

function BulkActionBar({
  selectedCount,
  onMove,
  onDelete,
  onClearSelection
}) {
  if (selectedCount === 0) return null;

  return (
    <div className="bulk-action-bar">
      <span className="selection-count">
        {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
      </span>

      <div className="bulk-actions">
        <button
          className="bulk-action-btn move"
          onClick={onMove}
          title="Move to folder"
        >
          <FolderIcon className="action-icon" />
          <span>Move</span>
        </button>

        <button
          className="bulk-action-btn delete"
          onClick={onDelete}
          title="Delete selected"
        >
          <TrashIcon className="action-icon" />
          <span>Delete</span>
        </button>

        <button
          className="bulk-action-btn cancel"
          onClick={onClearSelection}
          title="Clear selection"
        >
          <XMarkIcon className="action-icon" />
          <span>Clear</span>
        </button>
      </div>
    </div>
  );
}

export default BulkActionBar;
